<template>
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 7C0 4.79086 1.79086 3 4 3H11.6319C13.147 3 14.5321 3.85601 15.2096 5.21115L20.1041 15L28.8083 31.0974C30.2494 33.7625 28.3196 37 25.2898 37H4C1.79086 37 0 35.2091 0 33V7Z"
      fill="#2C719C"
    />
    <path
      d="M0 13C0 10.7909 1.79086 9 4 9H30C32.2091 9 34 10.7909 34 13V33C34 35.2091 32.2091 37 30 37H4C1.79086 37 0 35.2091 0 33V13Z"
      fill="#2C719C"
    />
    <path
      d="M2 13C2 11.8954 2.89543 11 4 11H30C31.1046 11 32 11.8954 32 13V33C32 34.1046 31.1046 35 30 35H4C2.89543 35 2 34.1046 2 33V13Z"
      fill="#1E577B"
    />
    <path
      d="M3 13C3 12.4477 3.44772 12 4 12H30C30.5523 12 31 12.4477 31 13V35C31 35.5523 30.5523 36 30 36H4C3.44771 36 3 35.5523 3 35V13Z"
      fill="white"
    />
    <path
      d="M3.29238 18.1135C3.70628 16.2924 5.32532 15 7.19291 15H35.2071C37.7028 15 39.5891 17.2602 39.1426 19.7155L36.5972 33.7155C36.2514 35.6175 34.5948 37 32.6617 37H4.0111C1.44421 37 -0.458311 34.6166 0.110565 32.1135L3.29238 18.1135Z"
      fill="#3982B0"
    />
  </svg>
</template>
